import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Animate } from '@/components/common/Animate';

import type { CreateStyled } from '@emotion/styled';

export const visuallyHiddenStyle = () => css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const VisuallyHidden = styled.span`
  ${visuallyHiddenStyle}
`;

interface destinationProps {
  target: string;
  isExternalLink: boolean;
  newTabText: string;
}

export const determineDestination = (
  href: string,
  isExternal: boolean | null = null,
): destinationProps => {
  const isExternalLink =
    isExternal ||
    (href && href.includes('platform.multiverse.io')) ||
    (href &&
      !href.includes('multiverse.io') &&
      !href.startsWith('/') &&
      !href.startsWith('#'));
  return {
    target: isExternalLink ? '_blank' : '_self',
    isExternalLink,
    newTabText: isExternalLink ? '(opens new window)' : '',
  };
};

export const transientOptions: Parameters<CreateStyled>[1] = {
  shouldForwardProp: (propName: string) => !propName.startsWith('$'),
};

export const stringToId = (str: string): string => {
  return str.toLowerCase().replaceAll(' ', '-');
};

export const ConditionalAnimateWrapper = ({
  children,
  animate,
}): JSX.Element => {
  return animate?.enabled ? (
    <Animate {...animate}>{children}</Animate>
  ) : (
    children
  );
};

export const formatDate = (date: string) => {
  const formattedDate = new Date(`${date}T00:00`).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  return formattedDate;
};
